interface IAttributionTouch {
  source: string;
  medium: string;
  campaign: string | null;
  referrer: string;
  landing: string;
}

export interface IAttribution {
  firstTouch: IAttributionTouch | null;
  lastTouch: IAttributionTouch | null;
}

function inferSourceFromReferrer(referrer: string): {
  source: string;
  medium: string;
} {
  if (!referrer) {
    return { source: 'direct', medium: 'none' };
  }
  if (referrer.includes('google.')) {
    return { source: 'google', medium: 'organic' };
  }
  if (referrer.includes('bing.')) {
    return { source: 'bing', medium: 'organic' };
  }
  if (referrer.includes('heureka')) {
    return { source: 'heureka', medium: 'referral' };
  }
  if (referrer.includes('perplexity')) {
    return { source: 'perplexity', medium: 'ai-referral' };
  }
  if (referrer.includes('chatgpt') || referrer.includes('openai')) {
    return { source: 'chatgpt', medium: 'ai-referral' };
  }
  if (referrer.includes('claude')) {
    return { source: 'claude', medium: 'ai-referral' };
  }
  return { source: 'referral', medium: 'referral' };
}

export function captureAttribution(): void {
  if (typeof window === 'undefined') {
    return;
  }

  const params = new URLSearchParams(window.location.search);
  const utmSource = params.get('utm_source')?.trim().toLowerCase() ?? null;
  const utmMedium = params.get('utm_medium')?.trim().toLowerCase() ?? null;
  const utmCampaign = params.get('utm_campaign')?.trim().toLowerCase() ?? null;
  const referrer = document.referrer.trim().toLowerCase();

  const { source, medium } = utmSource
    ? { source: utmSource, medium: utmMedium ?? 'unknown' }
    : inferSourceFromReferrer(referrer);

  if (source === 'direct' && !utmSource) {
    return;
  }

  const touch: IAttributionTouch = {
    source,
    medium,
    campaign: utmCampaign,
    referrer,
    landing: window.location.pathname,
  };

  try {
    if (!sessionStorage.getItem('attribution_first')) {
      sessionStorage.setItem('attribution_first', JSON.stringify(touch));
    }
    sessionStorage.setItem('attribution_last', JSON.stringify(touch));
  } catch {
    // sessionStorage unavailable (private mode edge case)
  }
}

export function getAttribution(): IAttribution {
  try {
    const first = sessionStorage.getItem('attribution_first');
    const last = sessionStorage.getItem('attribution_last');
    return {
      firstTouch: first ? (JSON.parse(first) as IAttributionTouch) : null,
      lastTouch: last ? (JSON.parse(last) as IAttributionTouch) : null,
    };
  } catch {
    return { firstTouch: null, lastTouch: null };
  }
}
